import { t } from "@lingui/macro";
import * as React from "react";
import { Path } from "react-native-svg";

import { Icon, IconProps } from "../../../primitive";

export const FolderIcon = (props: IconProps) => (
  <Icon viewBox="0 0 16 16" fill="none" title={t`Folder`} {...props}>
    <Path
      id="Vector"
      d="M12.8 13C13.1183 13 13.4235 12.8761 13.6485 12.6554C13.8736 12.4348 14 12.1355 14 11.8235V5.94118C14 5.62916 13.8736 5.32992 13.6485 5.10929C13.4235 4.88866 13.1183 4.76471 12.8 4.76471H8.06C7.85931 4.76663 7.66133 4.71918 7.48418 4.62669C7.30703 4.5342 7.15638 4.39963 7.046 4.23529L6.56 3.52941C6.45073 3.36675 6.30198 3.23322 6.1271 3.14082C5.95221 3.04842 5.75667 3.00003 5.558 3H3.2C2.88174 3 2.57652 3.12395 2.35147 3.34458C2.12643 3.56521 2 3.86445 2 4.17647V11.8235C2 12.1355 2.12643 12.4348 2.35147 12.6554C2.57652 12.8761 2.88174 13 3.2 13H12.8Z"
      stroke="#001A19"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </Icon>
);
